// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1Vpii","ranges":"BmiRanges_ranges__2Qg-G"};